import type { AxiosRequestConfig } from 'axios';
import { request, resolveApiBaseURL, buildCommonRequestHeaders } from '@dana/components';
import type { RequestMethod } from '@dana/components';
import {
  GuildInfoType,
  MemberInfoType,
  MasterSalary,
  MemberSalary,
  MembersDetailType,
  FlowItem,
  MemberTimeItem,
  AllInviteItemType,
  newFlowItem
} from './type';

const GUILD_PREFIX = '/guild';
const guildRequest = <T>(
  method: RequestMethod,
  url: string,
  data: any = null,
  config?: AxiosRequestConfig,
): Promise<T | undefined> => request<T>(method, `${GUILD_PREFIX}${url}`, data, config);

export const getGuildInfo = async (): Promise<GuildInfoType | undefined> =>
  await guildRequest('GET', `/info/v1/app/getGuildInfo`);

export const searchUser = async (key: string): Promise<MemberInfoType[] | undefined> =>
  await guildRequest('POST', `/info/v1/app/searchByKey`, {
    key,
  });

export const invite = async (
  guildId: number,
  userId: string,
): Promise<MemberInfoType[] | undefined> =>
  await guildRequest('POST', `/info/v1/app/apply/${guildId}/${userId}`);

export const membersList = async (guildId: number): Promise<MemberInfoType[] | undefined> =>
  await guildRequest('GET', `/info/v1/app/getGuildMembers/${guildId}`);

export const masterSalary = async (
  guildId: number,
  date: string,
  isHalfMonth?: boolean,
): Promise<MasterSalary | undefined> =>
  await guildRequest(
    'GET',
    `/salary/v2/getMasterSalary${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}`,
  );

export const memberSalary = async (
  guildId: number,
  date: string,
  uid: number,
  isHalfMonth?: boolean,
): Promise<MemberSalary | undefined> =>
  await guildRequest(
    'GET',
    `/salary/v2/getMasterLiveAndCoinSalary${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}/${uid}`,
  );

export const membersDetailList = async (
  guildId: number,
  date: string,
  isHalfMonth?: boolean,
): Promise<MembersDetailType[] | undefined> =>
  await guildRequest(
    'GET',
    `/salary/v2/getSalaryDetails${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}`,
  );

export const memberTimeList = async (
  memberId: number,
  date: string,
  guildId: number,
  isHalfMonth?: boolean,
): Promise<MemberTimeItem[] | undefined> =>
  await guildRequest(
    'GET',
    `/salary/v2/getAllByMemberId${isHalfMonth ? '/halfMonth' : ''}/${memberId}/${date}/${guildId}`,
  );

export const guildData = async (
  guildId: number,
  date: string,
  uid: number,
  isHalfMonth?: boolean,
): Promise<any> =>
  await fetch(
    `${(await resolveApiBaseURL())}${GUILD_PREFIX}/salary/v2/getGuildPage${isHalfMonth ? '/halfMonth' : ''}/${guildId}/${date}/${uid}`,
    {
      headers: buildCommonRequestHeaders(),
    },
  ).then((res) => res.json());

// 礼物流水配置
export const giftFlowConfig = async (
  date: string,
  isHalfMonth?: boolean,
): Promise<FlowItem[] | undefined> =>
  await guildRequest(
    'GET',
    `/salary/v2/getGuildGiftFlowSalaryConfigs${isHalfMonth ? '/halfMonth' : ''}/${date}`,
  );

// 钻石流水配置
export const coinFlowConfig = async (
  date: string,
  isHalfMonth?: boolean,
): Promise<FlowItem[] | undefined> =>
  await guildRequest(
    'GET',
    `/salary/v2/getGuildCoinSalaryConfigs${isHalfMonth ? '/halfMonth' : ''}/${date}`,
  );

export const salaryConnfig = async (
  date: string,
  isHalfMonth?: boolean,
): Promise<FlowItem[] | undefined> =>
  await guildRequest(
    'GET',
    `/salary/v2/getMasterSalaryConfigByMonth${isHalfMonth ? '/halfMonth' : ''}/${date}`,
  );

export const getAllInvite = async (): Promise<AllInviteItemType[] | undefined> =>
  await guildRequest('GET', `/info/v1/app/getAllInvite`);

export const agree = async (guildId: number): Promise<any> =>
  await guildRequest('POST', `/info/v1/app/agree/${guildId}`);

export const reject = async (guildId: number): Promise<any> =>
  await guildRequest('POST', `/info/v1/app/rejectApply/${guildId}`);

export const getFans = async (): Promise<MemberInfoType[] | undefined> =>
  await guildRequest('POST', `/info/v1/app/getFans`);

export const isMaster = async (uid: number): Promise<any> =>
  await guildRequest('GET', `/anchor/is-anchor?uid=${uid}`);


export type DayCoinRewardType = {
  "id": number,
  "guildDay": number,
  "userId": string,
  "giftFlowTotal": number,
  "reward": number,
  "createTime": number
}

export const getDayCoinReward = async (uid: number, start: number, end: number): Promise<DayCoinRewardType[] | undefined> =>
  await guildRequest('GET', `/info/getDayCoinReward?uid=${uid}&start=${start}&end=${end}`);


export const getNewConfig = async (
  date: string
): Promise<newFlowItem[] | undefined> =>
  await guildRequest<newFlowItem[]>('GET', `/salary/v2/getGuildMemberGiftFlowCoinConfigs/halfMonth/${date}`);

export const getNewConfigByMonth = async (
  month: number
): Promise<newFlowItem[] | undefined> =>
  await guildRequest<newFlowItem[]>('GET', `/salary/v2/getGuildMemberGiftFlowCoinConfigs/${month}`);
